<div class="item-selector__content-headers">
  <div class="item-selector__categories">
    <span>Category</span>
  </div>
  <div class="item-selector__items">
    <span>Name</span>
  </div>
  <div class="item-selector__description">
    <span>{{descriptionColumnTitle}}</span>
  </div>
  <div class="item-selector__preview">
    <ng-container *ngIf="itemActions">
      <ng-container [ngTemplateOutlet]="itemActions.templateRef" [ngTemplateOutletContext]="templateContext"></ng-container>
    </ng-container>
  </div>
</div>
<div class="item-selector__content">
  <div class="item-selector__categories">
    <ul class="item-selector__item-list item-selector__category-list">
      <li *ngFor="let category of categories; trackBy: categoryTrackBy; index as index"
          [class.selected]="selectedCategoryIndex === index"
          [hidden]="category.hidden"
          (click)="selectCategory(category, index)">
        <span>{{category.name}}</span>
      </li>
    </ul>
  </div>
  <div class="item-selector__items">
    <ng-container *ngIf="selectedCategory; else noCategory">
      <ul class="item-selector__item-list item-selector_item-list">
        <li *ngFor="let item of selectedCategoryItems; trackBy: itemTrackBy; index as index"
            [class.selected]="selectedItemIndex === index"
            [hidden]="item.hidden"
            (click)="selectItem(item, index)"
            class="text-ellipsis pr-8">
          <span *ngIf="item.highlightedName" [innerHtml]="item.highlightedName"></span>
          <span *ngIf="!item.highlightedName" [title]="item.name">{{item.name}}</span>
        </li>
      </ul>
    </ng-container>
    <ng-template #noCategory>

    </ng-template>
  </div>
  <div class="item-selector__description">
    <ng-container *ngIf="itemDescription">
      <ng-container [ngTemplateOutlet]="itemDescription.templateRef" [ngTemplateOutletContext]="templateContext"></ng-container>
    </ng-container>
  </div>
  <div class="item-selector__preview">
    <ng-container *ngIf="itemPreview">
      <ng-container [ngTemplateOutlet]="itemPreview.templateRef" [ngTemplateOutletContext]="templateContext"></ng-container>
    </ng-container>
  </div>
</div>
